import * as React from "react"
import * as Sentry from "@sentry/react"
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom"
import { desktopAppVersion, isDesktopApp } from "./desktop"

type BrowserSentryConfig = {
  dsn?: string
  environment?: string
  release?: string
  tracesSampleRate?: number
  sendDefaultPii?: boolean
  enableLogs?: boolean
}

type NanaUser = {
  id?: number | string | null
  email?: string | null
}

declare global {
  interface Window {
    sentryConfig?: BrowserSentryConfig
    nanaMe?: NanaUser
  }
}

let initialized = false

export function initSentry() {
  const config = window.sentryConfig
  if (initialized || !config?.dsn) return

  initialized = true

  Sentry.init({
    dsn: config.dsn,
    environment: config.environment,
    release: config.release,
    sendDefaultPii: config.sendDefaultPii ?? true,
    enableLogs: config.enableLogs ?? true,
    tracesSampleRate: config.tracesSampleRate ?? 1.0,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.consoleLoggingIntegration({ levels: ["warn", "error"] }),
    ],
  })

  setSentryUser(window.nanaMe)
  if (isDesktopApp()) Sentry.setTag("desktop_app", desktopAppVersion() ?? "unknown")
}

export function setSentryUser(user: NanaUser | undefined) {
  if (!initialized) return
  if (user?.id) Sentry.setUser({ id: String(user.id), email: user.email ?? undefined })
  else Sentry.setUser(null)
}

export { Sentry }
